import { axios } from "@/utils"

export default {
    redeemVoucher(code, checkinId=null) {
        if (checkinId) {
            return axios.post(`/v2/checkins/${checkinId}/redeem-voucher/`, {voucher_code: code.toUpperCase()})
        }
        return axios.post(`/v2/checkins/redeem-voucher/`, {voucher_code: code.toUpperCase()})
    }
}
